/**
 * =====================================================
 * CENTRAL DE IMAGENS - BEYOND CLASS
 * =====================================================
 * 
 * Este arquivo centraliza todas as imagens utilizadas no site.
 * 
 * COMO USAR:
 * 1. Baixe a imagem desejada e salve em /src/assets/images/
 * 2. Importe a imagem no topo deste arquivo
 * 3. Substitua a URL placeholder pela variável importada
 * 
 * CONVENÇÃO DE NOMES:
 * - Use kebab-case: hero-home-1.jpg, teacher-gabriel.jpg
 * - Prefixe por categoria: hero-, teacher-, gallery-, location-
 * 
 * TAMANHOS RECOMENDADOS:
 * - Hero/Banners: 1920x1080px (16:9)
 * - Cards/Galeria: 800x600px ou 600x400px
 * - Perfil/Avatar: 400x400px (1:1)
 * - Thumbnails: 300x200px
 */

// =====================================================
// IMPORTS DE IMAGENS LOCAIS
// =====================================================
// Imagens já baixadas - substitua os placeholders conforme adicionar novas
import homeColiseo from '../assets/images/home-coliseo.jpg';
import homePiramides from '../assets/images/home-piramides.jpg';
import homePiramides2 from '../assets/images/home-piramides-2.jpg';
import homeCavernas from '../assets/images/home-caverna.png';
import homeGelo from '../assets/images/home-gelo.png';
import destChachoeira from '../assets/images/dest-cachoeira.jpeg';
import destAurora from '../assets/images/dest-aurora.png';
import destDublin from '../assets/images/dest-dublin.jpeg';
import destCastelo from '../assets/images/dest-castelo.png';
import teacherElienai from '../assets/images/teacher-elienai.crop.png';
import teacher2 from '../assets/images/teacher-2.crop.jpg';
import teacher3 from '../assets/images/teacher-3.jpeg';
import aula1 from '../assets/images/aula1.jpg';
import aula2 from '../assets/images/aula2.jpeg';
import aula3 from '../assets/images/aula3.jpg';
import aula4 from '../assets/images/aula4.jpeg';
import aula5 from '../assets/images/aula5.jpeg';
import aula6 from '../assets/images/aula6.jpeg';
import aula33 from '../assets/images/aula33.jpg';
import aula7 from '../assets/images/aula7.jpg';
import aula8 from '../assets/images/aula8.jpg';
import aula9 from '../assets/images/aula9.jpg';
import aula10 from '../assets/images/aula10.jpg';
import aula11 from '../assets/images/aula11.jpg';
import exchange from '../assets/images/exchange.png';
import ex1 from '../assets/images/ex1.jpg';
import ex2 from '../assets/images/ex2.jpg';
import ex3 from '../assets/images/ex3.jpg';
import ex4 from '../assets/images/ex4.jpg';
import ex5 from '../assets/images/ex5.jpg';
import baloes from '../assets/images/baloes.jpg';

// Placeholders para imagens ainda não baixadas (URLs externas)
const PLACEHOLDER = {
  // Hero
  newYork: 'https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=1920',
  london: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1920',
  sydney: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=1920',
  toronto: 'https://images.unsplash.com/photo-1517935706615-2717063c2225?w=1920',
  
  // Professores
  teacherMale1: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
  teacherFemale1: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
  teacherMale2: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400',
  
  // Galeria/Aulas
  classroom1: aula1,
  classroom2: aula2,
  classroom3: aula3,
  classroom4: aula4,
  classroom5: aula33,
  classroom6: aula6,
  classroom7: aula7,
  classroom8: aula8,

  
  // Features
  study: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600',
  music: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600',
  board: 'https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=600',
  support: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600',
  
  // Online
  travel1: exchange,
  travel2: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600',
  travel3: 'https://images.unsplash.com/photo-1527631746610-bca00a040d60?w=600',
  
  // Outdoor
  cafe1: aula7,
  park1: aula8,
  cultural1: aula1,
  cafe2: aula9,
  beach1: aula10,
  cafe3: aula11,
  
  // Exchange
  londonBig: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200',
  paris: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200',
};

export const HOME_HERO_SLIDES = [
  {
    id: 'home-hero-1',
    url: homeCavernas, // ✅ Imagem local
    location: 'Roma, Itália',
    caption: 'O Coliseu - onde história e cultura se encontram',
    suggestedImage: '✅ Substituída por foto real',
    dimensions: '1920x1080',
  },
  {
    id: 'home-hero-2',
    url: homePiramides, // ✅ Imagem local
    location: 'Cairo, Egito',
    caption: 'As Pirâmides de Gizé - maravilhas do mundo antigo',
    suggestedImage: '✅ Substituída por foto real',
    dimensions: '1920x1080',
  },
  {
    id: 'home-hero-3',
    url: homeColiseo, // ✅ Imagem local
    location: 'Cairo, Egito',
    caption: 'Explorando a história milenar do Egito',
    suggestedImage: '✅ Substituída por foto real',
    dimensions: '1920x1080',
  },
  {
    id: 'home-hero-3',
    url: baloes, // ✅ Imagem local
    location: 'Cairo, Egito',
    caption: 'Explorando a história milenar do Egito',
    suggestedImage: '✅ Substituída por foto real',
    dimensions: '1920x1080',
  },
  {
    id: 'home-hero-4',
    url: homeGelo, // 🔄 Trocar: baixe e importe a imagem
    location: 'Toronto, Canadá',
    caption: 'Multiculturalismo e as muitas formas de falar inglês',
    suggestedImage: '🔄 Baixar: foto de viagem Toronto',
    dimensions: '1920x1080',
  },
];

export const HOME_DESTINATIONS_GRID = [
  {
    id: 'dest-coliseo',
    url: destChachoeira, // ✅ Imagem local
    alt: 'Roma',
    suggestedImage: '✅ Substituída',
    dimensions: '400x400',
  },
  {
    id: 'dest-piramides',
    url: destCastelo, // ✅ Imagem local
    alt: 'Egito',
    suggestedImage: '✅ Substituída',
    dimensions: '400x400',
  },
  {
    id: 'dest-piramides-2',
    url: homePiramides2, // ✅ Imagem local
    alt: 'Egito',
    suggestedImage: '✅ Substituída',
    dimensions: '400x400',
  },
  {
    id: 'dest-toronto',
    url: destAurora, // 🔄 Trocar
    alt: 'Toronto',
    suggestedImage: '🔄 Baixar: foto de viagem Toronto',
    dimensions: '400x400',
  },
  {
    id: 'dest-toronto',
    url: ex5, // 🔄 Trocar
    alt: 'Toronto',
    suggestedImage: '🔄 Baixar: foto de viagem Toronto',
    dimensions: '400x400',
  },
];

export const TEACHER_PHOTOS = [
    {
        id: 'teacher-elienai',
        name: 'Elienai Santos',
        url: teacherElienai, // 🔄 Trocar por: teacherElienai
        suggestedImage: '🔄 Baixar: teacher-elienai.jpg (400x400)',
        dimensions: '400x400',
    },
    {
        id: 'teacher-gabriel',
        name: 'Roger Santana',
        url: teacher2, // 🔄 Trocar por: teacherGabriel
        suggestedImage: '🔄 Baixar: teacher-gabriel.jpg (400x400)',
        dimensions: '400x400',
    },
    {
        id: 'teacher-tallyne',
        name: 'Tallyne',
        url: teacher3, // 🔄 Trocar
        suggestedImage: '🔄 Baixar: teacher-tallyne.jpg (400x400)',
        dimensions: '400x400',
    },
];

export const ABOUT_GALLERY = [
  {
    id: 'about-gallery-1',
    url: PLACEHOLDER.classroom1, // 🔄 Trocar
    caption: 'Aula ao ar livre no Parque da Jaqueira',
    suggestedImage: '🔄 Baixar: gallery-outdoor.jpg',
    dimensions: '600x400',
  },
  {
    id: 'about-gallery-2',
    url: PLACEHOLDER.classroom2, // 🔄 Trocar
    caption: 'Conversação em grupo',
    suggestedImage: '🔄 Baixar: gallery-group.jpg',
    dimensions: '600x400',
  },
  {
    id: 'about-gallery-3',
    url: PLACEHOLDER.classroom3, // 🔄 Trocar
    caption: 'Aulas interativas com material moderno',
    suggestedImage: '🔄 Baixar: gallery-workshop.jpg',
    dimensions: '600x400',
  },
  {
    id: 'about-gallery-4',
    url: PLACEHOLDER.classroom4, // 🔄 Trocar
    caption: 'Aulas de Português para estrangeiros',
    suggestedImage: '🔄 Baixar: gallery-coffee.jpg',
    dimensions: '600x400',
  },
  {
    id: 'about-gallery-5',
    url: PLACEHOLDER.classroom5, // 🔄 Trocar
    caption: 'Imersão cultural no Jardim do Baobá',
    suggestedImage: '🔄 Baixar: gallery-cultural.jpg',
    dimensions: '600x400',
  },
  {
    id: 'about-gallery-6',
    url: PLACEHOLDER.classroom6, // 🔄 Trocar
    caption: 'Ambiente acolhedor e descontraído',
    suggestedImage: '🔄 Baixar: gallery-private.jpg',
    dimensions: '600x400',
  },
];

export const PRIVATE_LESSONS_SLIDER = [
  {
    id: 'private-slide-1',
    url: PLACEHOLDER.classroom3, // 🔄 Trocar
    title: 'Grupos de até 4 pessoas',
    desc: 'Turmas pequenas para atenção personalizada e mais prática de conversação',
    suggestedImage: '🔄 Baixar: private-group.jpg (1200x800)',
    dimensions: '1200x800',
  },
  {
    id: 'private-slide-2',
    url: PLACEHOLDER.classroom4, // 🔄 Trocar
    title: 'Ambiente descontraído',
    desc: 'Aprenda inglês em um ambiente acolhedor e sem pressão',
    suggestedImage: '🔄 Baixar: private-ambiente.jpg',
    dimensions: '1200x800',
  },
  {
    id: 'private-slide-3',
    url: PLACEHOLDER.classroom2, // 🔄 Trocar
    title: 'Prática real',
    desc: 'Situações do dia a dia para você usar o inglês de verdade',
    suggestedImage: '🔄 Baixar: private-practice.jpg',
    dimensions: '1200x800',
  },
];

export const PRIVATE_LESSONS_FEATURES = [
  {
    id: 'feature-homework',
    url: PLACEHOLDER.study, // 🔄 Trocar
    title: 'Homeworks Personalizados',
    suggestedImage: '🔄 Baixar: feature-homework.jpg',
    dimensions: '600x400',
  },
  {
    id: 'feature-cultural',
    url: PLACEHOLDER.music, // 🔄 Trocar
    title: 'Imersão Cultural',
    suggestedImage: '🔄 Baixar: feature-cultural.jpg',
    dimensions: '600x400',
  },
  {
    id: 'feature-board',
    url: PLACEHOLDER.board, // 🔄 Trocar
    title: 'Board Interativo',
    suggestedImage: '🔄 Baixar: feature-board.jpg',
    dimensions: '600x400',
  },
  {
    id: 'feature-support',
    url: PLACEHOLDER.support, // 🔄 Trocar
    title: 'Suporte Contínuo',
    suggestedImage: '🔄 Baixar: feature-support.jpg',
    dimensions: '600x400',
  },
];

export const ONLINE_COURSES_HERO = [
  {
    id: 'online-hero-1',
    url: PLACEHOLDER.travel1, // 🔄 Trocar
    suggestedImage: '🔄 Baixar: online-travel-1.jpg',
    dimensions: '600x400',
  },
  {
    id: 'online-hero-2',
    url: PLACEHOLDER.travel2, // 🔄 Trocar
    suggestedImage: '🔄 Baixar: online-travel-2.jpg',
    dimensions: '600x400',
  },
  {
    id: 'online-hero-3',
    url: PLACEHOLDER.travel3, // 🔄 Trocar
    suggestedImage: '🔄 Baixar: online-travel-3.jpg',
    dimensions: '600x400',
  },
];

export const ONLINE_COURSES_VIDEO_PREVIEW = {
  id: 'online-video-preview',
  url: aula6,
  title: 'Greetings - Aula 1',
};

export const ONLINE_COURSES_THUMBNAILS = [
  {
    id: 'online-thumb-1',
    url: aula2,
    title: 'Family & Numbers',
  },
  {
    id: 'online-thumb-2',
    url: aula3,
    title: 'Describing People',
  },
  {
    id: 'online-thumb-3',
    url: aula4,
    title: 'Daily Routine',
  },
  {
    id: 'online-thumb-4',
    url: aula5,
    title: 'Food & Drinks',
  },
];

// =====================================================
// OUTDOOR LESSONS PAGE - GALERIA DE IMERSÕES
// =====================================================
export const OUTDOOR_GALLERY = [
  {
    id: 'outdoor-1',
    url: PLACEHOLDER.cafe1, // 🔄 Trocar
    location: 'Praia da Casa Caiada',
    neighborhood: 'Casa Caiada, Olinda',
    activity: 'Ordering coffee & pastries',
    suggestedImage: '🔄 Baixar: outdoor-cafe-1.jpg',
    dimensions: '800x600',
  },
  {
    id: 'outdoor-2',
    url: PLACEHOLDER.park1, // 🔄 Trocar
    location: 'Jardim do Baobá',
    neighborhood: 'Graças, Recife',
    activity: 'Nature vocabulary walk',
    suggestedImage: '🔄 Baixar: outdoor-park.jpg',
    dimensions: '800x600',
  },
  {
    id: 'outdoor-3',
    url: PLACEHOLDER.cultural1, // 🔄 Trocar
    location: 'Parque da Jaqueira',
    neighborhood: 'Jaqueira, Recife',
    activity: 'Cultural immersion',
    suggestedImage: '🔄 Baixar: outdoor-cultural.jpg',
    dimensions: '800x600',
  },
  {
    id: 'outdoor-4',
    url: PLACEHOLDER.cafe2, // 🔄 Trocar
    location: 'Furdunço Café',
    neighborhood: 'Tamarineira, Recife',
    activity: 'Business English brunch',
    suggestedImage: '🔄 Baixar: outdoor-cafe-2.jpg',
    dimensions: '800x600',
  },
  {
    id: 'outdoor-5',
    url: PLACEHOLDER.beach1, // 🔄 Trocar
    location: 'Mercado da Torre',
    neighborhood: 'Torre, Recife',
    activity: 'Conversation by the sea',
    suggestedImage: '🔄 Baixar: outdoor-beach.jpg',
    dimensions: '800x600',
  },
  {
    id: 'outdoor-6',
    url: PLACEHOLDER.cafe3, // 🔄 Trocar
    location: 'Nosso Café',
    neighborhood: 'Espinheiro, Recife',
    activity: 'Casual English morning',
    suggestedImage: '🔄 Baixar: outdoor-cafe-3.jpg',
    dimensions: '800x600',
  },
];

export const OUTDOOR_LOCATIONS = [
  {
    id: 'location-jaqueira',
    url: PLACEHOLDER.park1, // 🔄 Trocar
    title: 'Parque da Jaqueira',
    suggestedImage: '🔄 Baixar: location-jaqueira.jpg',
    dimensions: '400x300',
  },
];

// =====================================================
// EXCHANGE PAGE - EXPEDIÇÕES
// =====================================================

/**
 * GALERIA DE INTERCÂMBIOS - FÁCIL DE EDITAR
 * 
 * Para trocar as imagens:
 * 1. Salve suas fotos em /src/assets/images/exchange/
 * 2. Importe no topo do arquivo: import exchangeFoto1 from '../assets/images/exchange/foto1.jpg';
 * 3. Substitua as URLs abaixo pela variável importada
 * 
 * Tamanho recomendado: 800x600px ou similar
 */

// =====================================================
// 🏴󠁧󠁢󠁥󠁮󠁧󠁿 BRITISH ISLES - Irlanda, Escócia, Inglaterra
// =====================================================
// Capa da expedição (aparece como destaque)
const BRITISH_ISLES_COVER = 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200';

// Galeria de fotos - adicione ou remova quantas quiser
const BRITISH_ISLES_PHOTOS = [
  ex1, // Londres
  ex2,   // Edinburgh
  ex3, // Dublin
  ex4,   // Paisagem
  ex5, // Cidade
  exchange, // Grupo
];

// =====================================================
// 🇪🇺 EASTERN EUROPE - Alemanha, República Tcheca, Polônia
// =====================================================
// Capa da expedição (aparece como destaque)
const EASTERN_EUROPE_COVER = 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200';

// Galeria de fotos - adicione ou remova quantas quiser
const EASTERN_EUROPE_PHOTOS = [
  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600',   // Berlim
  'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=600', // Dresden
  'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=600', // Praga
  'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=600', // Cracóvia
  'https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=600', // Varsóvia
  'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600', // Grupo
];

// =====================================================
// EXPORTS - Não precisa editar abaixo
// =====================================================
export const EXCHANGE_BRITISH_ISLES = {
  cover: {
    id: 'exchange-british-cover',
    url: BRITISH_ISLES_COVER,
  },
  gallery: BRITISH_ISLES_PHOTOS.map((url, index) => ({
    id: `exchange-british-${index + 1}`,
    url,
  })),
};

export const EXCHANGE_EUROPEAN_CLASSICS = {
  cover: {
    id: 'exchange-europe-cover',
    url: EASTERN_EUROPE_COVER,
  },
  gallery: EASTERN_EUROPE_PHOTOS.map((url, index) => ({
    id: `exchange-europe-${index + 1}`,
    url,
  })),
};

// =====================================================
// RESUMO DE TODAS AS IMAGENS
// =====================================================
/**
 * TOTAL DE IMAGENS A SUBSTITUIR: ~50 imagens
 * 
 * Por página:
 * - Home: 8 imagens (4 hero + 4 destinos)
 * - About: 9 imagens (3 professores + 6 galeria)
 * - Private Lessons: 8 imagens (4 slider + 4 features)
 * - Online Courses: 3 imagens (hero background)
 * - Outdoor Lessons: 7 imagens (6 galeria + 1 location)
 * - Exchange: 14 imagens (2 covers + 12 galeria)
 * 
 * PRIORIDADE DE SUBSTITUIÇÃO:
 * 1. 🔴 Alta: Fotos dos professores (perfil)
 * 2. 🔴 Alta: Hero slides da Home (primeiras impressões)
 * 3. 🟡 Média: Galeria About/Outdoor (mostram as aulas reais)
 * 4. 🟡 Média: Fotos das expedições (Exchange)
 * 5. 🟢 Baixa: Backgrounds decorativos
 */

// =====================================================
// HELPER: Exportar todas as imagens como objeto único
// =====================================================
export const ALL_IMAGES = {
  home: {
    heroSlides: HOME_HERO_SLIDES,
    destinationsGrid: HOME_DESTINATIONS_GRID,
  },
  about: {
    teachers: TEACHER_PHOTOS,
    gallery: ABOUT_GALLERY,
  },
  privateLessons: {
    slider: PRIVATE_LESSONS_SLIDER,
    features: PRIVATE_LESSONS_FEATURES,
  },
  onlineCourses: {
    hero: ONLINE_COURSES_HERO,
  },
  outdoorLessons: {
    gallery: OUTDOOR_GALLERY,
    locations: OUTDOOR_LOCATIONS,
  },
  exchange: {
    britishIsles: EXCHANGE_BRITISH_ISLES,
    europeanClassics: EXCHANGE_EUROPEAN_CLASSICS,
  },
};
